import styles from "./StepHeader.module.scss";

interface IStepHeaderProps {
  step: 1 | 2;
}

export const StepHeader = ({ step }: IStepHeaderProps) => {
  return (
    <div className={styles.stepHeader}>
      <span className={styles.stepText}>{step} шаг из 2</span>

      <div className={styles.progress}>
        <span
          className={`${styles.progressItem} ${
            step >= 1 ? styles.progressItemActive : ""
          }`}
        />

        <span
          className={`${styles.progressItem} ${
            step >= 2 ? styles.progressItemActive : ""
          }`}
        />
      </div>
    </div>
  );
};